import { Injectable } from '@angular/core'
import { clientFilter } from '../models/client.model'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { HttpClient } from '@angular/common/http'

@Injectable({
	providedIn: 'root',
})
export class ClientService {
	constructor(private http: HttpClient) {}
	getClientDetails(id: number) {
		return this.http.get(`${ApiEndPoint.ClientProfileApi}?id=${id}`)
	}
	getClientProfileTableDetails(clientTableFilter: any) {
		return this.http.post(
			`${ApiEndPoint.ClientProfileTableApi}`,
			clientTableFilter
		)
	}
	getClientList(filter: clientFilter) {
		return this.http.post(ApiEndPoint.clientListApi, filter)
	}
	getClientWalletData(ClientId: number, CountryId: number) {
		return this.http.get(
			`${ApiEndPoint.GetClientWalletDataApi}?ClientId=${ClientId}&CountryId=${CountryId}`
		)
	}
	getWalletTransactionList(body: any) {
		return this.http.post(ApiEndPoint.GetWalletTransactionListApi, body)
	}
	SearchClientByName(body: any) {
		return this.http.post(ApiEndPoint.SearchClientByNameApi, body)
	}
}
